import { Typography } from "@mui/material";

export default function FormHeader() {
  return <Typography variant="h4">SKRUTINER PLATFORM</Typography>;
}
